export default "__VITE_ASSET__DM620KTF__"